import { ProgressBar as EtProgressBar } from "@ever-tutor/et-ui";

const ProgressBar = ({
  progress,
  color,
  height,
}: {
  progress: number;
  color: string;
  height: string;
}) => {
  return (
    <EtProgressBar
      progress={progress}
      color={color}
      height={height}
      aria-label={`Progress: ${Math.round(progress)}%`}
    />
  );
};

export default ProgressBar;
